export default "__VITE_ASSET__CxLaXTEN__"